/**
 * Utilidad para codificar/decodificar columnas del Dashboard en la URL.
 * Permite compartir configuración de columnas entre usuarios vía link.
 */

/**
 * Codifica columnas en una URL compartible con query param ?columns=base64
 * @param {Array} columns - Array de column IDs
 * @returns {string} URL completa con columnas codificadas
 */
export function encodeColumnsToUrl(columns) {
    const encoded = btoa(JSON.stringify(columns));
    const url = new URL(window.location.href);
    url.search = '';
    url.searchParams.set('columns', encoded);
    return url.toString();
}

/**
 * Decodifica columnas desde la URL actual (?columns=base64)
 * @returns {Array|null} Array de column IDs o null si no hay params
 */
export function decodeColumnsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('columns');
    if (!q) return null;

    try {
        const decoded = JSON.parse(atob(q));
        if (Array.isArray(decoded)) return decoded;
        return null;
    } catch (e) {
        return null;
    }
}

/**
 * Limpia el query param de columnas de la URL sin recargar la página
 */
export function clearColumnsUrlParam() {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, '', url.pathname);
}
